module.exports = __webpack_public_path__ + "img/brand13.fd33b95a.png";